import LocationRepoBase from 'eflex/services/location-repo-base';
import { service } from '@ember/service';
import { recursiveSave } from 'eflex/util/tree-helpers';
import { task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { maxOf } from '@eflexsystems/ramda-helpers';
import { isEmpty } from '@ember/utils';
import { prop } from 'ramda';
import { copyTask } from 'eflex/services/task-repo';

const getOrder = (siblings) => {
  if (isEmpty(siblings)) {
    return 0;
  }

  return maxOf(prop('order'), siblings) + 1;
};

export default class KineticOperationRepoService extends LocationRepoBase {
  @service taskConfigRepo;

  operations = this.store.peekAll('kinetic-operation');

  create(properties = {}) {
    properties.order = getOrder(this.operations);
    return super.create('kineticOperation', properties);
  }

  createAndSave = task(waitFor(async (properties = {}) => {
    const kineticOperation = this.create(properties);
    await kineticOperation.save();
    return kineticOperation;
  }));

  copyOperationTasks = task(waitFor(async (operation, targetOperation) => {
    await this.taskConfigRepo.loadTaskConfigs.perform(operation);

    operation.sortedChildren.forEach((taskLocation) => {
      copyTask(taskLocation, targetOperation, true);
    });

    await recursiveSave(targetOperation);
  }));
}
